import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DropdownWithClear from "./dropdownWithClear";
import LabelInput from "./labelInput";
import { ShipmentStatusList } from "../Utils/dataConstant";
import "../Screen/Admin/DispachOrder/dispachOrder.css";
import InputField from "./inputField";
import DatePicker from "./datePicker";
import moment from "moment";
import { containsNumber } from "../Utils/validators";
import { validateValueWithoutSpace } from "../Utils/validators";
// import { validateIsNumberOnlyErrMsg } from "../Utils/errorMsg";
import { getOrdersList, addShipment, updateShipment } from "../Screen/Publication/publicationSlice";
import { showSnackbar, hideSnackbar } from "../store/slices/snackbarSlice";
interface props {
  open: boolean;
  handleClose: Function;
  shipmentStatusData?: any;
  isPartialDispatchWindow?: boolean;
  startDate?: any;
  endDate?: any;
  Status?: any;
  productTypeID?: any;
  setDispatchOrderList?: any;
}

export default function DispatchOrderPopup(props: props) {
  const dispatch: Function = useDispatch<AppDispatch>();
  const { open, handleClose, shipmentStatusData, isPartialDispatchWindow, startDate, endDate, Status, productTypeID, setDispatchOrderList } = props;
  const [shipmentStatus, setShipmentStatus] = useState<any>();
  const [trackingId, setTrackingId] = useState<any>("");
  const [postBy, setPostBy] = useState("IndianPost");
  const [packageWeight, setPackageWeight] = useState<any>("");
  const [dispatchDate, setDispatchDate] = useState<any>(moment.utc(new Date()).format("YYYY-MM-DD"));
  const [deliveryDate, setDeliveryDate] = useState<any>(moment.utc(new Date()).format("YYYY-MM-DD"));
  const [orderedProduct, setOrderedProduct] = useState<any>([]);
  const [productShipmentArry, setProductShipmentArry] = useState<any>([]);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [active, setActive] = useState<any>();
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  const [filterList, setFilterList] = useState<any>([]);
  const [shipmentId, setShipmentId] = useState<any>();
  const [isShipmentStatus, setIsShipmentStatus] = useState<any>(false);

  useEffect(() => {
    setShipmentStatus(
      shipmentStatusData?.shipmentStatus === 0
        ? { _id: 0, name: "Pending" }
        : shipmentStatusData?.shipmentStatus === 1
          ? { _id: 1, name: "Partial Dispatched" }
          : shipmentStatusData?.shipmentStatus === 2
            ? { _id: 2, name: "Complete Dispatched" }
            : shipmentStatusData?.shipmentStatus === 3
              ? { _id: 3, name: "Delivered" }
              : ""
    )
    if (shipmentStatusData?.products?.length > 0) {
      const newArr = shipmentStatusData?.products?.map((item: any) => {
        return {
          productId: item?.productId,
          name: item?.name,
          orderedQty: item?.quantity,
          quantity: 0,
          dispatchedQty: item?.dispatchedQty,
          isChecked: false,
        };
      });
      setOrderedProduct(newArr)
    };
    if (shipmentStatusData?.shipments?.length > 0) {
      let partialDispatchData = shipmentStatusData?.shipments
      setProductShipmentArry(partialDispatchData);
      handleShipmentDetails("previousShipment", partialDispatchData[0], 0);
      setActive(0 + 1);
    };
    if (shipmentStatusData?.shipmentStatus === 0) {
      setIsDisabled(false);
    }
  }, [shipmentStatusData]);

  function closePopup(
    event: React.MouseEvent<SVGSVGElement, MouseEvent>
  ): void {
    handleClose();
  }

  const onchangeShipmentStatus = (value: any) => {
    setShipmentStatus(value);
  };
  const onchangeTrackingID = (value: any) => {
    setTrackingId(value);
  };
  const onChangeWeight = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setPackageWeight(value);
      }
    } else {
      setPackageWeight(value);
    }
  };

  const onChangeOrderDetails = (val: any, key: string, index: number, item: any) => {
    const newArr = JSON.parse(JSON.stringify(orderedProduct));
    if (key === "isChecked") {
      newArr[index][key] = val?.target?.checked;
      setOrderedProduct(newArr);
    } else if (key === "dispatchedQty") {
      const value = val.target.value.replace(/\D/g, '');
      newArr[index].dispatchedQty = Number(value);
      setOrderedProduct(newArr);
    } else if (key === "quantity") {
      const value = val.target.value.replace(/\D/g, '');
      let matchQty = Number(newArr[index].dispatchedQty) + Number(value);
      if (newArr[index].orderedQty >= Number(value) && newArr[index].orderedQty >= matchQty) {
        newArr[index].quantity = Number(value);
      } else {
        newArr[index].quantity = Number();
        dispatch(showSnackbar({ message: "Quantity Should not greater than Ordered Quantity!!", type: "error" }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
      };
      setOrderedProduct(newArr);
    }
  };
  const handleShipmentDetails = (key: string, data: any, index: number) => {
    if (key === "previousShipment") {
      setPostBy(data.postBy);
      setIsDisabled(true);
      setIsEmpty(true);
      onchangeTrackingID(data.trackingId);
      setDispatchDate(moment.utc(data.dispatchAt).format("YYYY-MM-DD"));
      onChangeWeight(data.weight);
      setOrderedProduct(data?.products);
      setShipmentId(data?._id);
      const filterShipmentStatusList = ShipmentStatusList.filter((status) => status._id === 3);
      setFilterList(filterShipmentStatusList);
      if (data?.status === 3) {
        setShipmentStatus({ _id: 3, name: "Delivered" });
        setDeliveryDate(moment.utc(data?.deliveredAt).format("YYYY-MM-DD"));
        setIsShipmentStatus(true);
        setFilterList([]);
      } else if (shipmentStatusData?.shipmentStatus === 2) {
        setShipmentStatus({ _id: 2, name: "Complete Dispatched" });
        setDeliveryDate(moment.utc(new Date()).format("YYYY-MM-DD"));
        setIsShipmentStatus(false);
        const filterShipmentStatusList = ShipmentStatusList.filter((status) => status._id === 2 || status._id === 3);
        setFilterList(filterShipmentStatusList);
      }
    } else if (key === "newShipment") {
      setIsDisabled(false);
      setIsShipmentStatus(false);
      onchangeTrackingID("");
      setDispatchDate(moment.utc(new Date()).format("YYYY-MM-DD"));
      onChangeWeight("");
      setPostBy("IndianPost");
      setActive("");
      setFilterList([]);
      setShipmentId("");
      setShipmentStatus(
        shipmentStatusData?.shipmentStatus === 0
          ? { _id: 0, name: "Pending" }
          : shipmentStatusData?.shipmentStatus === 1
            ? { _id: 1, name: "Partial Dispatched" }
            : shipmentStatusData?.shipmentStatus === 2
              ? { _id: 2, name: "Complete Dispatched" }
              : shipmentStatusData?.shipmentStatus === 3
                ? { _id: 3, name: "Delivered" }
                : ""
      );
      const newArr = shipmentStatusData?.products?.map((item: any) => {
        const shipData = {
          productId: item?.productId,
          name: item?.name,
          orderedQty: item?.quantity,
          quantity: 0,
          dispatchedQty: item?.dispatchedQty,
        }
        if (shipmentStatusData?.shipmentStatus === 2) {
          delete (shipData as any).quantity
        }
        return shipData;
      });
      setOrderedProduct(newArr);
    }
  };
  const addShipmentStatus = () => {
    const filterData = orderedProduct
      ?.filter((item: any) => item?.quantity !== undefined && item?.quantity !== null && item?.quantity !== 0)
      .map((item: any) => {
        const updatedQuantity = (item.dispatchedQty || 0) + item.quantity;
        const dispatchData: any = {
          productId: item.productId,
          name: item.name,
          orderedQty: item?.orderedQty,
          dispatchedQty: updatedQuantity,
        };
        if (shipmentStatus?._id !== 3) {
          dispatchData.quantity = item?.quantity;
        }
        return dispatchData;
      });
    const postData = {
      orderId: shipmentStatusData?._id,
      orderNo: shipmentStatusData?.orderNo,
      usersId: shipmentStatusData?.users?._id,
      addressId: shipmentStatusData?.addressId,
      status: shipmentStatus?._id,
      trackingId: trackingId,
      products: orderedProduct?.some((item: any) => "quantity" in item) ? filterData : orderedProduct,
      postBy: "INDIA POST",
      weight: packageWeight,
      dispatchAt: dispatchDate,
    };
    dispatch(addShipment({
      params: postData,
      callback: (res: any) => {
        if (res?.status === "success") {
          handleClose();
          setShipmentStatus(shipmentStatusData?.shipmentStatus === 0
            ? { _id: 0, name: "Pending" }
            : shipmentStatusData?.shipmentStatus === 1
              ? { _id: 1, name: "Partial Dispatched" }
              : shipmentStatusData?.shipmentStatus === 2
                ? { _id: 2, name: "Complete Dispatched" }
                : shipmentStatusData?.shipmentStatus === 3
                  ? { _id: 3, name: "Delivered" }
                  : "");
          setTrackingId('');
          setPackageWeight('');
          setDispatchDate(moment.utc(new Date()).format("YYYY-MM-DD"));
          const postData = {
            startDate: startDate,
            endDate: endDate,
            shipmentStatus: Status,
            productTypeId: productTypeID,
            skip: 0,
            limit: 10
          };
          dispatch(getOrdersList({
            params: postData,
            callback: (res: any) => {
              setDispatchOrderList(res?.data)
            },
            errorCallback: () => { }
          }));
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }))
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        }
      },
      errorCallback: (err: any) => {
        dispatch(showSnackbar({ message: err?.data?.msg, type: err?.data?.status }))
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
      }
    }))
  };
  const updateShipmentStatus = () => {
    // const completeDispatch = orderedProduct?.every((item: any) => item?.orderedQty === item?.dispatchedQty);
    if (shipmentStatus?._id !== 3) {
      dispatch(showSnackbar({ message: "Please Change Shipment Status to 'Delivered'", type: "error" }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    } else {
      const postData = {
        status: shipmentStatus?._id,
        deliveredAt: deliveryDate
      };
      dispatch(updateShipment({
        id: shipmentId,
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            handleClose();
            const postData = {
              startDate: startDate,
              endDate: endDate,
              shipmentStatus: Status,
              productTypeId: productTypeID,
              skip: 0,
              limit: 10
            };
            dispatch(getOrdersList({
              params: postData,
              callback: (res: any) => {
                setDispatchOrderList(res?.data)
              },
              errorCallback: () => { }
            }));
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }))
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (err: any) => {
          dispatch(showSnackbar({ message: err?.data?.msg, type: err?.data?.status }))
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        }
      }))
    }
  };

  useEffect(() => {
    if (!shipmentStatus || !trackingId || !packageWeight || !dispatchDate) {
      setIsEmpty(true);
    } else {
      setIsEmpty(false);
    }
  }, [shipmentStatus, trackingId, packageWeight, dispatchDate]);

  // useEffect(() => {
  //   const asada: any = shipmentStatusData?.shipmentStatus ;
  //   if (asada) {
  //     return  
  //   }
  // }, [shipmentStatusData])
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modelChat"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="dispachModeldiv p-3 col-md-6">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold mt-1">Shipment Details</h5>
              <div>
                <HighlightOffIcon
                  color="primary"
                  className="cursor"
                  onClick={closePopup}
                />{" "}
              </div>
            </div>
            <div className="shipement-button-holder">
              {isPartialDispatchWindow ?
                productShipmentArry.map((item: any, index: number) => (
                  <button
                    key={index}
                    type="button"
                    className={`btn me-1 ${active === index + 1 ? "active" : "outline"}`}
                    onClick={() => { handleShipmentDetails("previousShipment", item, index); setActive(index + 1) }}
                  >
                    Shipment {index + 1}
                  </button>
                ))
                : null}
              {shipmentStatusData?.shipmentStatus === 2 || shipmentStatusData?.shipmentStatus === 3 ? null : (
                <button type="button" className={`btn ${isDisabled ? "outline" : "active"}`}
                  onClick={() => handleShipmentDetails("newShipment", null, 0)}>New Shipment</button>
              )}
            </div>
            <div className="px-5 form-check mt-5">
              <div className="row mb-3">
                <div className="col-md-6 mb-3">
                  <LabelInput labelName={"Shipment Status"} isRequired />
                  <DropdownWithClear
                    labelName={"Select Shipment Status"}
                    setInputText={(value: any) => onchangeShipmentStatus(value)}
                    options={filterList?.length > 0 ? filterList : ShipmentStatusList}
                    value={shipmentStatus}
                    defaultValue={shipmentStatus?._id}
                    disabled={isShipmentStatus}
                  />
                </div>
                {shipmentStatus?._id !== 0 ? (
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Tracking ID "} isRequired />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Tracking ID "}
                      setInputText={(value: any) => onchangeTrackingID(value)}
                      value={trackingId}
                      disabled={isDisabled}
                    />
                  </div>
                ) : null}
                {shipmentStatus?._id !== 0 ? (
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Post By "} isRequired />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Post By "}
                      setInputText={(value: any) => setPostBy(value)}
                      value={postBy}
                      disabled={true}
                    />
                  </div>
                ) : null}
                {shipmentStatus?._id !== 0 ? (
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Dispatched Date"} />
                    <DatePicker
                      setInputText={(value: any) => {
                        setDispatchDate(value);
                      }}
                      value={dispatchDate}
                      disabled={isDisabled}
                    />
                  </div>
                ) : null}
                {shipmentId ? (
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Delivery Date"} />
                    <DatePicker
                      setInputText={(value: any) => {
                        setDeliveryDate(value);
                      }}
                      value={deliveryDate}
                      disabled={isShipmentStatus}
                    />
                  </div>
                ) : null}
                {shipmentStatus?._id !== 0 ? (
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Weight "} isRequired />
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Package Weight (Kg)"}
                      setInputText={(value: any) => onChangeWeight(value)}
                      value={packageWeight}
                      disabled={isDisabled}
                    />
                  </div>
                ) : null}
                {shipmentStatus?._id !== 0 ? (
                  <div className="col-md-12 mb-3">
                    <LabelInput labelName={"Product details"} isRequired />
                    <div className="row border rounded py-2">
                      {orderedProduct.map((item: any, index: number) => {
                        return (
                          <div className="mb-3" key={index}>
                            <div className="row">
                              <div className="col-md-12 mb-2">
                                <LabelInput labelName={"Product Name"} />
                                <p className={`font16`}>
                                  {item.name}
                                </p>
                              </div>
                              <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Ordered Quntity"} />
                                <InputField
                                  placeholder={item?.orderedQty}
                                  setInputText={() => ("")}
                                  value={item?.orderedQty}
                                  disabled={true}
                                />
                              </div>
                              <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Dispatch Quntity"} />
                                <input type="text"
                                  className="form-control"
                                  placeholder={"Enter Previous Dispatch Quantity"}
                                  onChange={(val: any) => (onChangeOrderDetails(val, "dispatchedQty", index, item))}
                                  value={item?.dispatchedQty}
                                  maxLength={5}
                                  disabled={true}
                                />
                              </div>
                              {"quantity" in item ?
                                <div className="col-md-4 mb-3">
                                  <LabelInput labelName={"Quntity"} />
                                  <input type="text"
                                    className="form-control"
                                    placeholder={"Enter Quantity"}
                                    onChange={(val: any) => (onChangeOrderDetails(val, "quantity", index, item))}
                                    value={item?.quantity}
                                    maxLength={5}
                                    disabled={isDisabled}
                                  />
                                </div>
                                :
                                null
                              }
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                ) : null}
                {shipmentStatus?._id !== 3 || shipmentStatusData?.shipmentStatus !== 3 ? (
                  <div className="text-center my-3">
                    <button type="button" className="submitBtn mb-3 w-50 font18 py-2" onClick={shipmentId ? updateShipmentStatus : addShipmentStatus} disabled={isEmpty}>Save and Proceed</button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
